import 'whatwg-fetch';
import { middle_dev, middle_key_val, middle_env } from 'config';
import { couponsWeb_controller } from 'config';

const authHeader = new Headers();
authHeader.append('Accept', 'application/json');
authHeader.append('Content-Type', 'application/json');

export default class BannerService{
    static massive() {
        /*
        *   @massiveBanner
        *   Devuelve los banners que se pueden mostrar a todo público, sin necesidad de logueo
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/banners?ambito=${middle_env}&tipo=1`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static public() {
        /*
        *   @publicBanner
        *   Devuelve los banners que se pueden mostrar a todo público logueado, aunque no está restringido por logueo
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/banners?ambito=${middle_env}&tipo=3`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static client() {
        /*
        *   @clientBanner
        *   Devuelve los banners para clientes específicos, restringidos por sesión activa
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/banners`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static bonus() {
        /*
        *   @publicBanner
        *   Devuelve los banners que se pueden mostrar a todo público logueado, aunque no está restringido por logueo
        *   
        *   OUT     |   data[payload]                   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/banners?ambito=${middle_env}&tipo=4`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
}